import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'

const Disclosures = ({ title = null, subtitle = null, defaultOpen = false, error = false, children }) => (
    <Disclosure
        defaultOpen={defaultOpen}
        as="div"
        className="bg-white border rounded-lg border-stroke dark:border-strokedark dark:bg-boxdark"
    >
        <div className="flex flex-row items-center justify-between w-full px-5 py-3 bg-gray dark:bg-graydark">
            <DisclosureButton
                className={`flex-1 font-medium text-left cursor-pointer ${error ? 'text-danger' : 'text-black dark:text-white'}`}
            >
                {title}
            </DisclosureButton>
            {subtitle}
        </div>
        <DisclosurePanel className="p-5">{children}</DisclosurePanel>
    </Disclosure>
)

export default Disclosures
